import { useContext, useMemo } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { UserContext } from '../contexts/UserContext';

const accountHasFeature = (accountSlug: string, featureCode: string) => {
  if (featureCode === 'facebookAds') {
    return accountSlug === 'OurRitual' ||
      accountSlug === 'Cyder_ai' ||
      accountSlug === 'Cyder_Facebook_test'
      ? true
      : false;
  } else if (featureCode === 'comparisonLists') {
    return accountSlug === 'Cyder_ai' ||
      accountSlug === 'Comparisun' ||
      accountSlug === 'comparison-test' ||
      accountSlug === 'Z2A-Digital' ||
      accountSlug === 'top-compared' ||
      accountSlug === 'LeadsLive' ||
      accountSlug === 'comparefinancetoday' ||
      accountSlug === 'Tango' ||
      accountSlug === 'PicksWise'
      ? true
      : false;
  } else if (featureCode === 'domains:add') {
    return accountSlug === 'Harel' ? false : true;
  } else if (featureCode === 'dynamicPages:create:fields:extraLink') {
    return accountSlug === 'Harel' ? false : true;
  }

  return true;
};

export const useHasFeature = function (
  featureCode:
    | 'facebookAds'
    | 'comparisonLists'
    | 'domains:add'
    | 'dynamicPages:create:fields:extraLink'
    | 'viewFinancialData',
): boolean {
  const { isSupportAdmin } = useContext(AuthContext);
  const { selectedAccount, selectedAccountMember, role } =
    useContext(UserContext);

  const hasFeature = useMemo(() => {
    const accountSlug = selectedAccount?.data().slug;
    const hasFeature = accountHasFeature(accountSlug ?? '', featureCode);
    if (!hasFeature) {
      return false;
    }

    if (role === 'admin' || isSupportAdmin) {
      return true;
    }

    if (featureCode === 'viewFinancialData') {
      return selectedAccountMember?.features?.includes(featureCode) ?? false;
    }

    return true;
  }, [
    featureCode,
    isSupportAdmin,
    role,
    selectedAccount,
    selectedAccountMember?.features,
  ]);

  return hasFeature;
};
